import { Component } from "@angular/core";
import { SimpleTableColumn } from "../custom-table-column/simple-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'simple-table-value',
    template: '<span [ngClass]="getClass()">{{ getValue() | localize }}</span>'
})
export class SimpleTableValueComponent extends CustomTableValueComponent<SimpleTableColumn> {
}